import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "company-block" }
const _hoisted_2 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_portfel_icon = _resolveComponent("portfel-icon")!
  const _component_ShadowBlock = _resolveComponent("ShadowBlock")!

  return (_ctx.company)
    ? (_openBlock(), _createBlock(_component_ShadowBlock, {
        key: 0,
        style: {"margin-bottom":"16px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_portfel_icon),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.company.name), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}